// src/data/products.js
// Hard‑coded sample catalog.
// Replace or extend with an API call / CMS later.

export const products = [
  {
    id: '1',
    name: 'Modern Leather Armchair',
    price: 1499,
    image:
      '/images/gothic_chair1.png',
    category: 'chairs',
    description:
      'Comfortable modern leather armchair with premium materials',
    images: [
      '/images/gothic_chair1.png',
      '/images/gothic_chair2.png'
    ],
    model: {
    glb: '/models/gothic_chair.glb',
    },
    rating: 4.8,
    reviews: 124,
  },
  {
    id: '2',
    name: 'Wooden Dining Table',
    price: 1299,
    image:
      '/images/mahogany_table1.png',
    category: 'tables',
    description: 'Solid wood dining table perfect for family gatherings',
    images: [
      '/images/mahogany_table1.png',
      '/images/mahogany_table2.png',
    ],
    model: {
    glb: '/models/mahogany_table.glb',
    },
    rating: 4.9,
    reviews: 89,
  },
  {
    id: '3',
    name: 'Luxury Modern Sofa',
    price: 2199,
    image:
      '/images/modern_sofa1.png',
    category: 'sofas',
    description: 'Luxurious modern sofa with premium comfort and style',
    images: [
      '/images/modern_sofa1.png',
     '/images/modern_sofa2.png',
    ],
    model: {
    glb: '/models/modern__sofa.glb',
    },
    rating: 4.7,
    reviews: 156,
  },
  {
    id: '4',
    name: 'Office Ergonomic Chair',
    price: 459,
    image:
      '/images/office_chair1.png',
    category: 'chairs',
    description: 'Ergonomic office chair designed for all‑day comfort',
    images: [
      '/images/office_chair1.png',
      '/images/office_chair2.png',
    ],
    model: {
    glb: '/models/office_chair.glb',
    },
    rating: 4.6,
    reviews: 201,
  },
  {
    id: '5',
    name: 'Glass Coffee Table',
    price: 699,
    image:
      '/images/table1.png',
    category: 'tables',
    description: 'Modern glass coffee table with sleek metal frame',
    images: [
      '/images/table1.png',
      '/images/table2.png',
    ],
    model: {
    glb: '/models/table.glb',
    },
    rating: 4.5,
    reviews: 78,
  },
  {
    id: '6',
    name: 'Sectional Sofa Set',
    price: 3299,
    image:
       '/images/sofa1.png',
    category: 'sofas',
    description: 'Large sectional sofa perfect for spacious living rooms',
    images: [
      '/images/sofa1.png',
      '/images/sofa1.png',
    ],
    model: {
    glb: '/models/sofa.glb',
    },
    rating: 4.8,
    reviews: 92,
  },
  {
    id: '7',
    name: 'Double Seater Sofa',
    price: 2999,
    image:
       '/images/Sofa_double1.png',
    category: 'sofas',
    description: 'Double seater sofa perfect for small living rooms',
    images: [
      '/images/Sofa_double1.png',
      '/images/Sofa_double2.png',
    ],
    model: {
    glb: '/models/sofa_double.glb',
    },
    rating: 4.5,
    reviews: 90,
  },
  {
    id: '8',
    name: 'Study Table',
    price: 1099,
    image:
      '/images/study_table1.png',
    category: 'tables',
    description: 'Modern study table with different cabinets',
    images: [
      '/images/study_table1.png',
      '/images/study_table2.png',
    ],
    model: {
    glb: '/models/study_table.glb',
    },
    rating: 4.8,
    reviews: 99,
  },
  {
    id: '9',
    name: 'Elegant Sofa Chair',
    price: 3459,
    image:
      '/images/sofa_chair1.png',
    category: 'chairs',
    description: 'Elegant Sofa chair designed for all‑day comfort and style',
    images: [
      '/images/sofa_chair1.png',
      '/images/sofa_chair2.png',
    ],
    model: {
    glb: '/models/sofa_chair.glb',
    },
    rating: 4.6,
    reviews: 201,
  },
  {
    id: '10',
    name: 'Casual Chair',
    price: 450,
    image:
      '/images/chair1.png',
    category: 'chairs',
    description: 'Casual chair designed for your everyday life',
    images: [
      '/images/chair1.png',
      '/images/chair2.png',
    ],
    model: {
    glb: '/models/chair.glb',
    },
    rating: 4.1,
    reviews: 101,
  },
  {
    id: '11',
    name: 'Folding Table',
    price: 999,
    image:
      '/images/folding_table1.png',
    category: 'tables',
    description: 'Folding table designed for multi-household purpose',
    images: [
      '/images/folding_table1.png',
      '/images/folding_table2.png',
    ],
    model: {
    glb: '/models/folding_table.glb',
    },
    rating: 3.9,
    reviews: 78,
  },
];
